<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
    <div class="card-header pb-0">
      <h6>Lista de tareas</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">

        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Opciones</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Producción asignada</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Detalle tarea</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Cant. recibida</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Cant. entregada</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Cant. defectuosa</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha recibido</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha entregado</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha validado</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >observación</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Total ganancia</th>
            </tr>
          </thead>
          <tbody>
            <tr  v-for="value in data" :key="value.id">

              <td class="align-middle text-center">
                <div style="display: flex;justify-content: center; align-items: center;gap: 10px;height: 100%;">
                  <!-- Admin: solo visualiza estado, no puede modificar -->

                  <!-- 1) Pendiente total: sin recibido -->
                  <span
                    v-if="value.received_date == null"
                    class="status-circle status-circle--pending"
                    title="Pendiente de recibido"
                  ></span>

                  <!-- 2) Recibido pero no entregado: círculo con check blanco -->
                  <span
                    v-if="value.received_date!=null && value.delivered_date == null"
                    class="status-circle status-circle--selected"
                    title="Recibido, pendiente de entrega"
                  >
                    <span class="status-circle__check">✔</span>
                  </span>

                  <!-- 3) Recibido y entregado (independientemente de validación): solo check verde -->
                  <span
                    v-if="value.received_date!=null && value.delivered_date!=null"
                    class="status-final-check"
                    title="Recibido y entregado"
                  >
                    <i class="fa fa-check"></i>
                  </span>
                </div>

              </td>

              <td class="align-middle text-center">
                <span class="badge badge-sm" :class="productionTypeBadgeClass(value)">
                  {{ productionTypeLabel(value) }}
                </span>
              </td>

              <td class="align-middle">
                <div class="text-secondary text-xs font-weight-bold">
                  Tipo: {{ productionTypeLabel(value) }}
                </div>
                <div
                  class="text-secondary text-xs font-weight-bold"
                  v-if="value.production && value.production.consecutivo"
                >
                  Producción: {{ value.production.consecutivo }}
                </div>
                <div
                  class="text-secondary text-xs font-weight-bold"
                  v-if="value.production_oven && value.production_oven.oven"
                >
                  Horno: {{ value.production_oven.oven.name }}
                </div>
                <div class="text-secondary text-xs font-weight-bold" v-if="value?.model?.model?.name">
                  Referencia: {{  value?.model?.model?.name  }}
                </div>
              </td>
              <td class="align-middle text-center">
                {{ value?.received_quantity }}
              </td>
              <td class="align-middle text-center">
                {{ value?.delivered_quantity }}
              </td>
              <td class="align-middle text-center">
                {{ value?.rejected_quantity }}
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ isValidDate(value.received_date) ? new Date(value.received_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ isValidDate(value.delivered_date) ? new Date(value.delivered_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ isValidDate(value.validated_date) ? new Date(value.validated_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                {{ value.observation }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                {{ parseFloat(value.total).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </span>
              </td>

             
            </tr>
           
          </tbody>
        </table>

        <div class="pagination p-3">
          <!-- Recorremos los links para generar los botones -->
          <a 
            v-for="link in links" 
            :key="link.label" 
            class="page-item cursor-pointer" 
            @click="fetchData(link.url)" 
            :disabled="!link.url || link.active" 
            :class="{ 'active': link.label === currentPage.toString() }"
          >
            {{ link.label }}
          </a>
        </div>

      </div>

    
    </div>
  </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'ProjectsList',
  computed: {
    ...mapGetters('productionUsers', ['allData','currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
        return this.$store.state.productionUsers.currentPage; // Obtiene la página actual
    },
    lastPage() {
        return this.$store.state.productionUsers.lastPage; // Obtiene la última página
    },
    data() {
        return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['productionUsers/links']; // Retorna los links
    },
  },
  methods: {
    /** Tipo de relación: Producción, Horno, Cargue o Descargue según campos de la BD */
    productionTypeLabel(value) {
      if (!value) return '—';
      // Registros asociados a horno
      if (value.production_oven_id) {
        const mod = Number(value.modulo);
        if (mod === 3) return 'Cargue';
        if (mod === 4) return 'Descargue';
        return 'Horno';
      }
      // Registros asociados a producción general (extrusión / secado)
      if (value.production_id) return 'Producción';
      // Sin relación clara
      return 'Sin producción';
    },
    productionTypeBadgeClass(value) {
      const label = this.productionTypeLabel(value);
      if (label === 'Producción') return 'bg-gradient-info';
      if (label === 'Cargue') return 'bg-gradient-warning';
      if (label === 'Descargue') return 'bg-gradient-success';
      if (label === 'Horno') return 'bg-gradient-dark';
      return 'bg-gradient-secondary';
    },
    async fetchData(pageUrl = null) {
      await this.$store.dispatch('productionUsers/fetchData',pageUrl); 
    },
    isValidDate(date) {
      // Verifica si el valor es nulo, indefinido o vacío
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async checkReceived(value) {
      try {
        const result = await Swal.fire({
          title: 'Recibir tarea',
          text: 'Se marcará la tarea como recibida con la cantidad asignada.',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar',
          cancelButtonText: 'Cancelar',
        });

        if (!result.isConfirmed) return;

        // Solo registrar fecha; la cantidad recibida queda igual que en la asignación
        value.received_date = new Date().toISOString().slice(0, 10);

        const response = await this.$store.dispatch("productionUsers/save", value);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire(
            'Tarea recibida',
            'Fecha registrada correctamente.',
            'success'
          );

          this.fetchData();
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async checkDelivered(value) {
  try {
    const { value: formValues } = await Swal.fire({
      title: 'Entregar Tarea',
      html: `
        <label for="swal-input-cant" class="form-label">Cantidad entregada:</label>
        <input id="swal-input-cant" type="number" class="form-control" placeholder="Cantidad entregada" min="0">
        
        <label for="swal-input-rechazada" class="form-label mt-2">Cantidad rechazada:</label>
        <input id="swal-input-rechazada" type="number" class="form-control" placeholder="Cantidad rechazada" min="0">

        <label for="swal-input-obs" class="form-label mt-2">Observación:</label>
        <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación"></textarea>
      `,
      focusConfirm: false,
      preConfirm: () => {
        const cant = parseInt(document.getElementById('swal-input-cant').value, 10);
        const rechazada = parseInt(document.getElementById('swal-input-rechazada').value, 10);
        const obs = document.getElementById('swal-input-obs').value;

        if ((isNaN(cant) || cant < 0) || (isNaN(rechazada) || rechazada < 0)) {
          Swal.showValidationMessage('Debe ingresar valores válidos para ambas cantidades.');
          return;
        }

        return { cant, rechazada, obs };
      },
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, aceptar!',
      cancelButtonText: 'Cancelar',
    });

    if (formValues) {
      const payload = {
        ...value,
        delivered_date: new Date().toISOString().slice(0, 10),
        delivered_quantity: formValues.cant,
        rejected_quantity: formValues.rechazada,
        observation: formValues.obs,
      };

      const response = await this.$store.dispatch("productionUsers/save", payload);
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Tarea Entregada!',
          'Excelente trabajo.',
          'success'
        );
        this.fetchData();
      } else {
        throw new Error(response.data.message || 'Error al guardar el registro');
      }
    }
  } catch (error) {
    console.error("Error al guardar el registro:", error);
    await Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.message || 'Error al guardar el registro',
    });
  }
}
,
  },
  mounted() {
    this.fetchData(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page-item {
  margin: 0 5px;
}
.active {
  font-weight: bold; /* Estilo para la página activa */
}

/* Estilos del estado en columna Opciones (admin) */
.status-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #bdc3c7; /* borde gris en pendiente */
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;    /* nunca fondo */
}

/* Pendiente: solo borde gris, sin check */
.status-circle--pending {
  border-color: #bdc3c7;
}

/* Seleccionado (recibido + entregado, sin validar): borde verde, check blanco */
.status-circle--selected {
  border-color: #2ecc71;
}

.status-circle__check {
  font-size: 12px;
  line-height: 1;
  color: #ffffff;            /* check blanco mientras está en progreso */
}

/* Proceso finalizado: solo un check verde sólido, sin círculo */
.status-final-check i {
  color: #2ecc71;
  font-size: 18px;
}
</style>